/*!
 
=========================================================
* DealerClick 2.0 - v1.0
=========================================================
 
* Product Page: https://dealerclick.com
* Copyright 2020 RoarinLion (https://dealerclick.com)
 
* Coded by DealerClick Software **RoarinLion))
 
=========================================================
 
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 
*/
import React, { useEffect, useState } from "react";
import { getSettings } from "api/SettingsAPI";
import { retrieveFailAlert } from "component/dc/modal/SweetAlerts";
import NavBar from "../../component/dc/tab/NavTabsHolder";
import Loading from "component/dc/load/Loading.js";
import { useHistory, useLocation } from "react-router-dom";
import useRoute from "helperFunction/UseRoute";
import { PATHS } from "Constants";
import useCurrentSettingStore from "store/SettingStore";
import { useFromUser } from "store/LocalStorageHelper";
import SignUps from "./settingsTabs/signUp/SignUps";
import DealTemplate from "./settingsTabs/dealTemplates/DealTemplate";
import ProfilePage from "./settingsTabs/userManagement/profile/ProfilePage";
import CompanyInfoTab from "./settingsTabs/userManagement/company/CompanyInfoTab";
import CompanyEmployeesPage from "./settingsTabs/userManagement/employees/CompanyEmployeesPage";
import useIsOwnerOrAdmin from "./settingsTabs/userManagement/useIsOwnerOrAdmin";
import { showApiError } from "../../helperFunction/ApiErrorHandler";
import MessageTemplates from "../communication/template/MessageTemplates";
import { TemplateVariableProvider } from "../../helperFunction/TemplateVariableContext";
import TemplateVariableInit from "../../helperFunction/TemplateVariableInit";
import DealSettings from "../../component/dc/deal/dealSettings/DealSettings";
import InventorySettings from "./settingsTabs/InventoryDefault/InventorySetting";

const SettingsPage = () => {
	const history = useHistory();
	const location = useLocation();
	const dealerID = useFromUser("dealerID");
	const locationID = useFromUser("locationID");
	const newRoute = useRoute(PATHS.DASHBOARD);

	let activeTab = 0;

	if (location?.state?.tab === "signUp") {
		activeTab = 4;
	} else if (location?.state?.tab === "dealerBond") {
		activeTab = 1;
	}

	const isOwnerOrAdmin = useIsOwnerOrAdmin();
	const { setSettingFields } = useCurrentSettingStore();

	const [isLoading, setIsLoading] = useState(true);
	const [showProfile, setShowProfile] = useState(false);

	const getData = () => {
		getSettings(dealerID, locationID).then(
			(res) => {
				console.log(res);
				//set res to store.
				setSettingFields(res.data.content);
				setIsLoading(false);
			},
			(err) => {
				console.log(err);

				if (!err.isGeneralError) {
					showApiError(err, retrieveFailAlert);
					history.push(newRoute);
				}
			}
		);
	};

	useEffect(
		() => {
			if (isOwnerOrAdmin) {
				getData();
				setShowProfile(false);
			} else {
				setIsLoading(false);
				setShowProfile(true);
			}
		},
		// eslint-disable-next-line
		[isOwnerOrAdmin]
	);

	const tabs = [
		"Profile",
		"Dealership Info",
		"Employees",
		"Deal Default",
		"Sign Ups",
		"Deal Template",
		"Message Templates",
		"Inventory Default",
	];

	const tabComponents = [
		<ProfilePage />,
		<CompanyInfoTab />,
		<CompanyEmployeesPage />,
		<DealSettings isDeal={false} />,
		<SignUps />,
		<DealTemplate />,
		<MessageTemplates />,
		<InventorySettings />,
	];

	return (
		<TemplateVariableProvider>
			<TemplateVariableInit isDeal>
				<div className="mx-0 px-3 justify-content-center content">
					{isLoading && <Loading />}
					{showProfile && (
						<div className="content">
							<ProfilePage />
						</div>
					)}
					{!showProfile && !isLoading && (
						<NavBar
							navClass="nav-pills-primary justify-content-center nav nav-pills"
							active={activeTab}
							tabs={tabs}
							tabComponents={tabComponents}
						/>
					)}
				</div>
			</TemplateVariableInit>
		</TemplateVariableProvider>
	);
};

export default SettingsPage;
